<template>
    <div :id="idName" :class="'row ' + className + ' ' + listLayoutClass">
        <slot v-for="item in dataList" :data="item"></slot>
    </div>
</template>
<script>
    import DataSource from '@/models/DataSource/DataSource';
    export default {
        props: {
            value: {
                default: "",
                type: String,
            },
            className: {
                default: "",
                type: String,
            },
            idName: {
                default: "",
                type: String,
            }, 
            listLayout: {
                default: "flow",
                type: String,
            },
            dataSourceId: {
                default: "",
                type: [Number, String],
            },
            filterBy: {
                default: "",
                type: [Number, String],
            },
            data : 
            {
                default: function() {return [];},
                type: Array,
            },
        },
        data() {
            return {
                items : []
            };
        },
        mounted() {
            if (this.dataSourceId != null && this.dataSourceId != "" && this.dataSourceId != undefined) {
                this.getDataSource();
            }
        },
        computed: {
            listLayoutClass() {
                return "list-" + this.listLayout
            },
            dataList() {
                if (this.data != null && this.data.length > 0) {
                    return this.data;
                }

                return this.items;
            }
        },
        methods: {
            getDataSource() {
                if (this.dataSourceId == null || this.dataSourceId == "" || this.dataSourceId == undefined) return;

                this.isBusy = true;
                DataSource.getData(this, this.dataSourceId)
                .then(result => { 
                    if (Array.isArray(result)) {
                        if (result.length > 0) {
                            this.items = result;
                        }
                    }
                    this.isBusy = false;
                })
                .catch(error => { 
                    this.isBusy = false; 
                });
            }
        }

    }
</script>